import { render, staticRenderFns } from "./promocion-prevencion-ver.vue?vue&type=template&id=4609b006&scoped=true&"
import script from "./promocion-prevencion-ver.vue?vue&type=script&lang=js&"
export * from "./promocion-prevencion-ver.vue?vue&type=script&lang=js&"
import style0 from "./promocion-prevencion-ver.vue?vue&type=style&index=0&id=4609b006&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4609b006",
  null
  
)

export default component.exports